__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "platform";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@ant-design/icons", "4.8.3", () => (Promise.all([__webpack_require__.e(624), __webpack_require__.e(111), __webpack_require__.e(884), __webpack_require__.e(136), __webpack_require__.e(69)]).then(() => (() => (__webpack_require__(5111))))));
			register("@kne/react-fetch", "1.5.7", () => (Promise.all([__webpack_require__.e(701), __webpack_require__.e(201), __webpack_require__.e(884), __webpack_require__.e(366)]).then(() => (() => (__webpack_require__(3201))))));
			register("@kne/react-text-escape", "0.1.4", () => (Promise.all([__webpack_require__.e(884), __webpack_require__.e(92)]).then(() => (() => (__webpack_require__(8711))))));
			register("@kne/remote-loader", "1.4.6", () => (Promise.all([__webpack_require__.e(701), __webpack_require__.e(467), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(1467))))));
			register("@loadable/component", "5.16.7", () => (Promise.all([__webpack_require__.e(939), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(8939))))));
			register("antd", "5.11.1", () => (Promise.all([__webpack_require__.e(624), __webpack_require__.e(682), __webpack_require__.e(884), __webpack_require__.e(469), __webpack_require__.e(486), __webpack_require__.e(136)]).then(() => (() => (__webpack_require__(3682))))));
			register("axios", "0.27.2", () => (__webpack_require__.e(854).then(() => (() => (__webpack_require__(854))))));
			register("classnames", "2.5.1", () => (__webpack_require__.e(139).then(() => (() => (__webpack_require__(8139))))));
			register("dayjs", "1.11.23", () => (__webpack_require__.e(446).then(() => (() => (__webpack_require__(446))))));
			register("js-cookie", "3.0.8", () => (__webpack_require__.e(880).then(() => (() => (__webpack_require__(1880))))));
			register("lodash", "4.18.1", () => (__webpack_require__.e(536).then(() => (() => (__webpack_require__(3536))))));
			register("md5", "2.3.0", () => (__webpack_require__.e(268).then(() => (() => (__webpack_require__(9268))))));
			register("moment", "2.31.0", () => (__webpack_require__.e(178).then(() => (() => (__webpack_require__(6178))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-router-dom", "6.30.6", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(884), __webpack_require__.e(486)]).then(() => (() => (__webpack_require__(3245))))));
			register("react", "18.2.0", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(453).then(() => (() => (__webpack_require__(6453))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};